import type { Media, MediaQuery } from "../../interface/media"
import type { Page, UUID } from "../../interface/publications"
import { businessApi, postBotTags } from "./api"

export const mediaApi = businessApi.injectEndpoints({
  endpoints: (build) => ({
    uploadMedia: build.mutation<Media, File>({
      query: (file) => {
        const body = new FormData()
        body.append("file", file)
        // The browser owns the multipart boundary and Content-Type.
        return { url: "media", method: "POST", body }
      },
      invalidatesTags: (_result, error) =>
        error ? [] : [postBotTags.mediaList],
    }),
    getMediaList: build.query<Page<Media>, MediaQuery | void>({
      query: (args) => ({
        url: "media",
        params: {
          page: args?.page,
          limit: args?.limit,
          kind: args?.kind,
          status: args?.status,
        },
      }),
      providesTags: (result) => [
        postBotTags.mediaList,
        ...(result?.data.map(({ id }) => postBotTags.media(id)) ?? []),
      ],
    }),
    getMedia: build.query<Media, UUID>({
      query: (id) => `media/${id}`,
      providesTags: (_result, _error, id) => [postBotTags.media(id)],
    }),
    deleteMedia: build.mutation<void, UUID>({
      query: (id) => ({ url: `media/${id}`, method: "DELETE" }),
      transformResponse: () => undefined,
      invalidatesTags: (_result, error, id) =>
        error ? [] : [postBotTags.mediaList, postBotTags.media(id)],
    }),
  }),
})

export const {
  useUploadMediaMutation,
  useGetMediaListQuery,
  useGetMediaQuery,
  useLazyGetMediaQuery,
  useDeleteMediaMutation,
} = mediaApi
